export const API_CONSTANTS = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  LOGIN: "/login",
  ME: "/me",
  GET_SOCIETY_BY_ID: "/society",
  GET_RECENT_AWARDEES: "/recent-awardees",
  GET_ALL_COUNTS: "/counts",
  GET_ALL_AWARDS: "/awards",
  GET_AWARDEE_BY_ID: "/awardee",
  GET_AWARDEE_BY_ID_NAME: "/awardeeByAwardIdawardName",
  GET_AWARD_GRAPH_ID: "/awardGraph",
  GET_AWARD_GENDER_COMPUTE: "/awardGenderCompute",
  GET_AWARD_BY_ID: "/award",
  GET_AWARD_FILTER_OPTIONS: "/award-filter-options",
  GET_ORGANIZATION_OPTIONS: "/organization-options",
  GET_UTA_FACULTY_MASTER_DATA: "/master_uta_faculty_awards",
  GET_UTA_FACULTY_BY_ID: "/utaFaculty",
  GET_AWARDS_BY_SOCIETY_NUMBER: "/awardsBySocietyNumber",
  GET_AWARDS_BY_SEARCH_STRING: "/awardSearch",
  GET_ALL_SOCIETIES: "/societies",
  GET_SOCIETIES_BY_SEARCH_STRING: "/societySearch",
  GET_NETWORK_GRAPH_COUNTS: "/awards-combination",
  GET_NETWORK_GRAPH_AWARDEES: "/common-awardees",
  GET_MODEL_DATA: "/model-data",
  GET_ANALYSES: "/analyses",
  GET_ANALYSIS: "/analysis",
  GET_VERSION: "/version",
  GET_CLIENT_NETWORK: "/client-network",
  // RAG surface (used by the flag-gated /assessment, /rag and /chat pages).
  // No SIGNUP endpoint: self-serve registration is out of v1 (plan decision D12).
  //
  // RAG_ASSESS is a job starter, not a report generator: POST returns 202 { job_id }
  // and the page polls RAG_ASSESS/<job_id> for status. Generation takes ~110s, which
  // is past every proxy timeout in front of the worker, so it can never be synchronous.
  RAG_ASSESS: "/rag/assess",
  // GET RAG_TRACE/<trace_id> reads a stored trace back. (The POST upload was
  // removed from the UI; the backend route survives for CLI/internal use.)
  RAG_TRACE: "/rag/trace",
  // BASE_URL already ends in /api, so these are the paths BELOW it, exactly like
  // every constant above. chat_bp registers url_prefix="/api" (blueprints/chat.py:36).
  CHAT: "/chat",
  CHAT_HEALTH: "/chat/health",
  // Data sync page (admin only). GET ADMIN_SYNC lists every store with its state;
  // POST ADMIN_SYNC_JOBS { action, targets? } starts a check or sync and answers 202.
  ADMIN_SYNC: "/admin/sync",
  ADMIN_SYNC_JOBS: "/admin/sync/jobs",
};
